import React, { useEffect } from "react";
import {
  ArrowRight,
  Zap,
  Users,
  BarChart2,
  Mail,
  Phone,
  MapPin,
  ShieldCheck,
  TrendingUp,
  MessageSquare,
  Facebook,
  Twitter,
  Linkedin,
} from "lucide-react"; // Sosyal medya ikonları eklendi

const LandingPage = ({ onGoToLogin }) => {
  const logoPath = process.env.PUBLIC_URL + "/monapart.jpg"; // Logonuzun doğru yolda olduğundan emin olun

  useEffect(() => {
    const yearElement = document.getElementById("currentYearLanding");
    if (yearElement) {
      yearElement.textContent = new Date().getFullYear();
    }

    // Smooth scroll for anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href");
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
          });
        }
      });
    });
  }, []);

  const features = [
    {
      icon: <TrendingUp size={40} className="text-sky-600" />,
      title: "Kolay Aidat ve Finans Yönetimi",
      description:
        "Aidatlarınızı, ortak giderlerinizi ve tüm finansal hareketlerinizi kolayca tanımlayın, takip edin ve şeffaf bir şekilde raporlayın.",
    },
    {
      icon: <Users size={40} className="text-sky-600" />,
      title: "Kapsamlı Sakin ve Malik Yönetimi",
      description:
        "Tüm kat malikleri ve sakinlerin bilgilerini, iletişim detaylarını ve daire atamalarını tek bir güvenli platformda yönetin.",
    },
    {
      icon: <BarChart2 size={40} className="text-sky-600" />,
      title: "Detaylı ve Anlık Raporlama",
      description:
        "Gelir-gider durumu, borçlu listeleri, ödeme özetleri gibi kritik raporlara anlık olarak ulaşın, karar alma süreçlerinizi güçlendirin.",
    },
    {
      icon: <ShieldCheck size={40} className="text-sky-600" />,
      title: "Güvenli ve Şeffaf İşlemler",
      description:
        "Tüm verileriniz güvenli altyapımızda korunur. Finansal işlemlerde ve bilgi paylaşımında tam şeffaflık sunarız.",
    },
    {
      icon: <Zap size={40} className="text-sky-600" />,
      title: "Hızlı ve Kullanıcı Dostu Arayüz",
      description:
        "Modern ve sezgisel arayüzümüz sayesinde tüm işlemleri hızlıca gerçekleştirin, karmaşık süreçlerle zaman kaybetmeyin.",
    },
    {
      icon: <MessageSquare size={40} className="text-sky-600" />,
      title: "Etkili İletişim ve Duyuru Sistemi",
      description:
        "Sakinlerinizle kolayca iletişim kurun, önemli duyuruları anında paylaşın ve geri bildirimleri toplayın.",
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-800 font-sans antialiased overflow-x-hidden w-full">
      {/* Global Stiller */}
      <style>{`
        html { 
          scroll-behavior: smooth;
          width: 100%;
          overflow-x: hidden;
        }
        body {
          width: 100%;
          overflow-x: hidden;
          max-width: 100%;
        }
        .hero-bg-landing {
          background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
          position: relative;
          overflow: hidden;
          width: 100%;
        }
        .hero-bg-landing::before {
          content: '';
          position: absolute;
          top: -50px;
          right: -50px;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          background: rgba(56, 189, 248, 0.1);
          z-index: 0;
        }
        .hero-bg-landing::after {
          content: '';
          position: absolute;
          bottom: -100px;
          left: -100px;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          background: rgba(56, 189, 248, 0.08);
          z-index: 0;
        }
        .feature-card-landing {
          transition: all 0.3s ease-out;
          border: 1px solid rgba(226, 232, 240, 0.7);
          position: relative;
          z-index: 1;
          overflow: hidden;
        }
        .feature-card-landing::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(240, 249, 255, 0.7) 0%, rgba(224, 242, 254, 0.5) 100%);
          z-index: -1;
        }
        .feature-card-landing:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border-color: rgba(186, 230, 253, 0.5);
        }
        .cta-button-landing {
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        .cta-button-landing::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: all 0.5s ease;
        }
        .cta-button-landing:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
        }
        .cta-button-landing:hover::after {
          left: 100%;
        }
        .nav-link-landing {
          position: relative;
          transition: color 0.3s ease;
        }
        .nav-link-landing::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: -4px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #0284c7;
          transition: width 0.3s ease;
        }
        .nav-link-landing:hover::after, .nav-link-landing-active::after {
          width: 100%;
        }
        .contact-input {
          transition: all 0.3s ease;
          border: 1px solid rgba(226, 232, 240, 1);
        }
        .contact-input:focus {
          border-color: #0ea5e9;
          box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);
        }
        .section-heading {
          position: relative;
          display: inline-block;
        }
        .section-heading::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #0ea5e9, #38bdf8);
          border-radius: 3px;
        }
        .fullwidth-container {
          width: 100vw;
          position: relative;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;
        }
      `}</style>

      {/* Navigasyon */}
      <nav className="bg-white/90 backdrop-blur-md shadow-sm fixed w-full z-50 top-0">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
          <a href="#home" className="flex items-center space-x-3">
            <img
              src={logoPath}
              alt="MonApart Logosu"
              className="h-12 md:h-14 w-auto"
              style={{ zoom: 1.5 }}
            />
            <span className="font-bold text-2xl text-sky-700">MonApart</span>
          </a>
          <div className="hidden md:flex items-center space-x-2">
            <a
              href="#home"
              className="nav-link-landing text-gray-700 hover:text-sky-600 px-3 py-2 rounded-md text-base font-medium nav-link-landing-active"
            >
              Ana Sayfa
            </a>
            <a
              href="#features"
              className="nav-link-landing text-gray-700 hover:text-sky-600 px-3 py-2 rounded-md text-base font-medium"
            >
              Özellikler
            </a>
            <a
              href="#about"
              className="nav-link-landing text-gray-700 hover:text-sky-600 px-3 py-2 rounded-md text-base font-medium"
            >
              Hakkımızda
            </a>
            <a
              href="#contact"
              className="nav-link-landing text-gray-700 hover:text-sky-600 px-3 py-2 rounded-md text-base font-medium"
            >
              İletişim
            </a>
          </div>
          <div>
            <button
              onClick={onGoToLogin}
              className="bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 px-6 rounded-lg shadow-md cta-button-landing text-base"
            >
              Online Giriş
            </button>
          </div>
          <div className="md:hidden">
            <button className="text-gray-700 hover:text-sky-600 focus:outline-none">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Bölümü */}
      <section
        id="home"
        className="hero-bg-landing pt-32 md:pt-40 pb-20 md:pb-32 text-center relative w-full"
      >
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="inline-block mb-4 px-4 py-1 bg-sky-100 rounded-full text-sky-700 font-medium text-sm">
            Yönetim İşlerinizi Kolaylaştırın
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-sky-800 mb-6 leading-tight">
            Apartman Yönetiminde{" "}
            <span className="text-sky-600 inline-block">
              Zahmetsiz Çözümler
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-10 max-w-4xl mx-auto">
            MonApart ile aidat takibi, finansal yönetim, sakin iletişimi ve tüm
            yönetim süreçleri parmaklarınızın ucunda. Şeffaf, modern ve
            kullanıcı dostu platformumuzla tanışın!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onGoToLogin}
              className="bg-sky-600 hover:bg-sky-700 text-white font-bold py-3.5 px-10 rounded-lg text-lg shadow-xl hover:shadow-2xl cta-button-landing flex items-center justify-center group w-full sm:w-auto"
            >
              Hemen Başlayın
              <ArrowRight
                size={20}
                className="ml-2 group-hover:translate-x-1 transition-transform"
              />
            </button>
            <a
              href="#features"
              className="text-sky-700 font-semibold py-3.5 px-8 border-2 border-sky-600 rounded-lg hover:bg-sky-50 transition-colors duration-300 flex items-center justify-center w-full sm:w-auto"
            >
              Özelliklerimiz
            </a>
          </div>
        </div>
      </section>

      {/* Özellikler Bölümü */}
      <section id="features" className="py-20 bg-white w-full">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-sky-700 mb-6 section-heading">
              MonApart'ın Sunduğu Avantajlar
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Yönetiminizi dijitalleştirerek zaman kazanın, verimliliği artırın
              ve sakin memnuniyetini en üst düzeye çıkarın.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="feature-card-landing p-8 rounded-xl shadow-md text-center bg-white"
              >
                <div className="mb-6 flex justify-center">{feature.icon}</div>
                <h3 className="text-xl font-semibold text-sky-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hakkımızda Bölümü */}
      <section
        id="about"
        className="py-20 bg-sky-50 relative overflow-hidden w-full"
      >
        <div className="absolute -right-20 -top-20 w-64 h-64 rounded-full bg-sky-100 opacity-70"></div>
        <div className="absolute -left-20 -bottom-20 w-80 h-80 rounded-full bg-sky-100 opacity-70"></div>
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-sky-700 mb-6 section-heading">
              Biz Kimiz?
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              MonApart olarak, apartman ve site yönetim süreçlerini modernize
              etme vizyonuyla yola çıktık.
            </p>
          </div>
          <div className="bg-white shadow-lg rounded-2xl p-8 md:p-10 max-w-5xl mx-auto">
            <div className="text-gray-700 space-y-6 text-left md:text-lg leading-relaxed">
              <p>
                Yılların getirdiği tecrübe ve teknolojiye olan tutkumuzla,
                yöneticilerin ve sakinlerin hayatını kolaylaştıracak, şeffaf ve
                etkili bir platform geliştirdik. Amacımız, karmaşık yönetim
                süreçlerini basitleştirerek, herkes için daha yaşanabilir ve
                huzurlu bir ortak yaşam alanı oluşturmaktır.
              </p>
              <p>
                Ekibimiz, yazılım geliştirme, kullanıcı deneyimi ve müşteri
                ilişkileri alanlarında uzman profesyonellerden oluşmaktadır.
                Sürekli olarak geri bildirimlerinizi dinliyor, platformumuzu
                geliştiriyor ve en iyi hizmeti sunmak için çalışıyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* İletişim Bölümü */}
      <section id="contact" className="py-20 bg-white w-full">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-sky-700 mb-6 section-heading">
              İletişime Geçin
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Soru, öneri veya demo talepleriniz için bize ulaşın. Size yardımcı
              olmaktan mutluluk duyarız!
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <form action="#" method="POST">
                <div className="mb-5">
                  <label
                    htmlFor="name_landing"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Adınız Soyadınız
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name_landing"
                    className="contact-input mt-1 block w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none sm:text-sm"
                    placeholder="Adınız Soyadınız"
                  />
                </div>
                <div className="mb-5">
                  <label
                    htmlFor="email_landing"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    E-posta Adresiniz
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email_landing"
                    className="contact-input mt-1 block w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none sm:text-sm"
                    placeholder="ornek@mail.com"
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="message_landing"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Mesajınız
                  </label>
                  <textarea
                    id="message_landing"
                    name="message"
                    rows="4"
                    className="contact-input mt-1 block w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none sm:text-sm"
                    placeholder="Mesajınızı buraya yazın..."
                  ></textarea>
                </div>
                <div>
                  <button
                    type="submit"
                    className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-base font-medium text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 cta-button-landing"
                  >
                    Mesajı Gönder
                  </button>
                </div>
              </form>
            </div>
            <div className="space-y-6 pt-8 md:pt-0">
              <h3 className="text-2xl font-semibold text-sky-800 mb-4">
                Diğer İletişim Kanalları
              </h3>
              <div className="flex items-start space-x-3 p-4 hover:bg-sky-50 rounded-lg transition-colors">
                <Mail size={24} className="text-sky-600 mt-1" />
                <div>
                  <h4 className="font-medium text-gray-700">E-posta</h4>
                  <a
                    href="mailto:info@monapart.com"
                    className="text-sky-600 hover:underline"
                  >
                    info@monapart.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 hover:bg-sky-50 rounded-lg transition-colors">
                <Phone size={24} className="text-sky-600 mt-1" />
                <div>
                  <h4 className="font-medium text-gray-700">Telefon</h4>
                  <a
                    href="tel:+900000000000"
                    className="text-sky-600 hover:underline"
                  >
                    +90 (000) 000 00 00
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3 p-4 hover:bg-sky-50 rounded-lg transition-colors">
                <MapPin size={24} className="text-sky-600 mt-1" />
                <div>
                  <h4 className="font-medium text-gray-700">Adres</h4>
                  <p className="text-gray-600">
                    Örnek Mah. Teknoloji Cad. No:123 <br />
                    İstanbul, Türkiye
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-sky-800 to-sky-900 text-sky-100 py-12 w-full">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center items-center space-x-3 mb-6">
            <img src={logoPath} alt="MonApart Logosu" className="h-12 w-auto" />
            <span className="font-bold text-xl text-white">MonApart</span>
          </div>
          <p className="text-lg font-semibold mb-2">
            Modern, şeffaf ve etkili apartman yönetimi.
          </p>
          <div className="flex justify-center space-x-6 my-6">
            <a
              href="#"
              aria-label="Facebook"
              className="text-sky-300 hover:text-white transition-colors p-2 bg-sky-800/50 rounded-full"
            >
              <Facebook size={20} />
            </a>
            <a
              href="#"
              aria-label="Twitter"
              className="text-sky-300 hover:text-white transition-colors p-2 bg-sky-800/50 rounded-full"
            >
              <Twitter size={20} />
            </a>
            <a
              href="#"
              aria-label="LinkedIn"
              className="text-sky-300 hover:text-white transition-colors p-2 bg-sky-800/50 rounded-full"
            >
              <Linkedin size={20} />
            </a>
          </div>
          <div className="border-t border-sky-700/50 pt-6 mt-6">
            <p className="text-sm text-sky-400">
              © <span id="currentYearLanding"></span> MonApart - Tüm Hakları
              Saklıdır.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
